// extracted by mini-css-extract-plugin
module.exports = {"editorsPanel":"EditorsPanel_editorsPanel__2-O0K","active":"EditorsPanel_active__1ixxv"};